import { lazy } from 'react'
import { Navigate, type RouteObject, useLocation, useParams } from 'react-router-dom'

const RequestMaterialPage = lazy(() => import('./pages/request-material'))
const DetailRequestPage = lazy(() => import('./pages/detail-request'))
const PickingOperatorPage = lazy(() => import('./pages/picking-rm-operator'))
const SerahTerimaPage = lazy(() => import('./pages/serah-terima-produksi'))
const RekapPengambilanPage = lazy(() => import('./pages/rekap-pengambilan'))

/** Tautan lama `request-saya` / `daftar-request` → menu gabungan; query (`?form=…`, `?created=…`) ikut terbawa. */
const LegacyListRedirect = () => {
  const { search } = useLocation()
  return <Navigate to={`../request-material${search}`} replace />
}

const LegacyDetailRedirect = () => {
  const { id } = useParams()
  return <Navigate to={`../../request-material/${id}`} replace />
}

/**
 * Cluster C06 Request Production RM — REQ-01 Request Material (satu menu: daftar + Buat Request, v7.50),
 * REQ-02A (request-material/:id), REQ-03 (picking-rm-operator), REQ-04 (serah-terima-produksi),
 * REQ-06 (rekap-pengambilan). `request-saya` dan `daftar-request` lama hanya dialihkan.
 */
const requestProductionRoutes: RouteObject[] = [
  {
    path: 'request-production',
    children: [
      {
        path: 'request-material',
        children: [
          { index: true, element: <RequestMaterialPage /> },
          { path: ':id', element: <DetailRequestPage /> }
        ]
      },
      { path: 'request-saya', element: <LegacyListRedirect /> },
      {
        path: 'daftar-request',
        children: [
          { index: true, element: <LegacyListRedirect /> },
          { path: ':id', element: <LegacyDetailRedirect /> }
        ]
      },
      { path: 'picking-rm-operator', element: <PickingOperatorPage /> },
      { path: 'serah-terima-produksi', element: <SerahTerimaPage /> },
      { path: 'rekap-pengambilan', element: <RekapPengambilanPage /> }
    ]
  }
]

export default requestProductionRoutes
